export default __webpack_public_path__ + "static/media/22-TvisVognmandsforretning.2e699201.png";